import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How to hire .NET developers?",
    answer: `<p>Hire a .NET Developer in 4 Simple Steps</p>
    <ul>
    <li>Share Your Needs<p>Provide us with your project requirements and preferences, and we’ll reach out to understand your specific needs.</p></li>
     <li>Connect with Top Talent<p>Within 48 hours, we’ll present you with 3 to 5 pre-vetted candidates who are best suited for your project.</p></li>
      <li>Interview Easily<p>Conduct interviews effortlessly with our streamlined process.</p></li>
       <li>Hire with Assurance<p>Make your final selection and hire with complete confidence.</p></li>
    </ul>`,
  },
  {
    question: "Why should I hire dedicated .NET developers?",
    answer: `<p>Hiring dedicated .NET developers guarantees quicker project completion with reduced costs. These developers focus exclusively on your projects, providing additional time and attention. Other advantages include:</p>
    <ul>
    <li>The development team operates as an in-house team</li>
     <li>Skilled and experienced development team</li>
     <li>No start-up fees or hidden costs</li>
      <li>Quality product delivery</li>
      <li>Complete control over the project</li>  
      <li>Cost-effective and flexible hiring options</li>  
    </ul>`,
  },
  {
    question: "What types of software applications can be developed with .NET?",
    answer: `<p>.NET is an extensive framework ideal for back-end web development. With .NET, you can create a variety of software applications, including web apps, enterprise web portals, websites, CRMs, CMS, eCommerce portals, and more.</p>`,
  },
  {
    question: "What benefits does .NET provide for application development?",
    answer: `<p>.NET provides several benefits, including cross-platform compatibility, a vast array of framework libraries, strong security features, language interoperability, and seamless integration with other Microsoft technologies.</p>`,
  },
  {
    question:
      "How can I benefit from outsourcing .net development to your team?",
    answer: `<p>By outsourcing .NET development to our team, you gain access to experienced developers, cost-efficient solutions, scalability, quicker time-to-market, and professional guidance throughout the entire development process.</p>`,
  },
  {
    question:
      "What kind of support do you offer post-completion of a .NET project?",
    answer: `<p>We offer continuous support and maintenance services to guarantee the seamless functioning of your .NET applications. This includes bug fixes, updates, security patches, and performance enhancements.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#fff" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Hire .NET developers FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
